import React, { useEffect, useState } from "react";
import axios from "axios";
import "./CaseSizes.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../AuthContext";

const CaseSizes = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [caseSizes, setCaseSizes] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const { mobile } = useAuth();

  useEffect(() => {
    fetchProducts();
    fetchCaseSizes();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/products/download`
      );
      setProducts(response.data);
      filterProducts(response.data, "");
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchCaseSizes = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/case_sizes`
      );
      const sizes = response.data.reduce(
        (acc, item) => ({
          ...acc,
          [item.Product_id + "-" + item.Company]: item.Case_Size,
        }),
        {}
      );
      setCaseSizes(sizes);
    } catch (error) {
      console.error("Error fetching case sizes:", error);
    }
  };

  const handleCaseSizeChange = (e, product) => {
    const newSize = e.target.value;
    setCaseSizes({
      ...caseSizes,
      [product.id + "-" + product.company]: newSize,
    });
  };

  const saveCaseSize = async (product) => {
    const caseSize = caseSizes[product.id + "-" + product.company];
    if (!caseSize || caseSize.trim() === "") {
      return;
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/case_sizes`, {
        Product_id: product.id,
        Company: product.company,
        Case_Size: caseSize,
      });
      toast.success("Case size updated successfully");
    } catch (error) {
      console.error("Error saving case size:", error);
      toast.error("Failed to update case size");
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    filterProducts(products, value);
  };

  const filterProducts = (products, search) => {
    const searchLower = search.toLowerCase();
    const allowedPacking = [
      "60ml",
      "60 ml",
      "100ml",
      "100 ml",
      "170ml",
      "170 ml",
      "150 ml",
      "150ml",
      "200ml",
      "200 ml",
      "120ml",
      "120 ml",
      "100gm",
      "100 gm",
      "200gm",
      "200 gm",
      "30ml",
      "30 ml",
      "15ml",
      "15 ml",
      "10ml",
      "10 ml",
      "75gm",
      "75 gm",
      "5gm",
      "5 gm",
      "10gm",
      "10 gm",
      "15gm",
      "15 gm",
      "20gm",
      "20 gm",
      "30gm",
      "30 gm",
      "50gm",
      "50 gm",
      "75ml",
      "75 ml",
    ];
    const uniqueImages = new Set();
    const filtered = products
      .filter((product) => {
        const packing = product.packing.toLowerCase();
        const category = product.category.toLowerCase();
        const image = product.product_image;
        if (!uniqueImages.has(image)) {
          uniqueImages.add(image);
          return (
            product.brand_name.toLowerCase().includes(searchLower) &&
            (allowedPacking.some((size) => packing.includes(size)) ||
              ["injectable", "infusion"].some((pack) =>
                category.includes(pack)
              ))
          );
        }
        return false;
      })
      .sort((a, b) => a.brand_name.localeCompare(b.brand_name));

    setFilteredProducts(filtered);
  };

  return (
    <div className="case-sizes-container">
      <h1>Case Sizes</h1>
      <input
        type="text"
        placeholder="Search product..."
        className="search-bar"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <table>
        <thead>
          <tr>
            <th>Brand Name</th>
            <th>Case Size</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((product) => (
            <tr key={product.id + "-" + product.company}>
              <td>
                {product.brand_name} --- {product.packing.split(" ")[0]}
              </td>
              <td>
                {mobile === "8725092149" ? (
                  <input
                    type="number"
                    value={caseSizes[product.id + "-" + product.company] || ""}
                    onChange={(e) => handleCaseSizeChange(e, product)}
                    onBlur={() => saveCaseSize(product)}
                  />
                ) : (
                  // Display the case size without an input field for users with other mobile numbers
                  caseSizes[product.id + "-" + product.company]
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ToastContainer position="bottom-center" />
    </div>
  );
};

export default CaseSizes;
